/**
 * 日本/韩国/台湾/法国/德国/马来西亚 兜底页面
 */

 import React from "react"
 import ReactDOM from "react-dom"
 import { Page_Overseas_Default } from "../components/page/overseas_default";
 
 if(window.quotedata){
   ReactDOM.render(
     <Page_Overseas_Default quotedata={window.quotedata}/>,
     document.getElementById('app')
   )  
 }
 
 